import { useCallback } from "react";

export function useSystemEmailPreviewHandler(
  entryId: string,
  onPreview: (entryId: string) => void
) {
  return useCallback(() => onPreview(entryId), [entryId, onPreview]);
}
